import React, { ChangeEvent, FC } from 'react';
import { Checkbox, FormControlLabel, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PostSource, SearchPostsFilter } from 'api';

interface Props {
  filters: SearchPostsFilter;
  setFilters: (filters: SearchPostsFilter) => void;
}

const Options: FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  function onChangeUserGenerated(e: ChangeEvent, checked: boolean) {
    if (checked) {
      setFilters({ ...filters, source: PostSource.User });
      return;
    }

    setFilters({ ...filters, source: null });
  }

  return (
    <Grid container>
      <Grid xs={3}>
        <Typography variant="body2">{t('common:options')}</Typography>
      </Grid>

      <Grid xs={8}>
        <Grid container>
          <Grid xs={6}>
            <FormControlLabel
              control={<Checkbox checked={filters.is_branded} />}
              label={t('common:branded')}
              onChange={(e, checked) => setFilters({ ...filters, is_branded: checked })}
            />
          </Grid>

          <Grid xs={6}>
            <FormControlLabel
              control={<Checkbox checked={filters.is_shareable} />}
              label={t('common:shareable')}
              onChange={(e, checked) => setFilters({ ...filters, is_shareable: checked })}
            />
          </Grid>

          <Grid xs={6}>
            <FormControlLabel
              control={<Checkbox checked={filters.is_engageable} />}
              label={t('posting:engageable')}
              onChange={(e, checked) => setFilters({ ...filters, is_engageable: checked })}
            />
          </Grid>

          <Grid xs={6}>
            <FormControlLabel
              control={<Checkbox checked={filters.source === PostSource.User} />}
              label={t('search:userGenerated')}
              onChange={onChangeUserGenerated}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Options;
